import React from 'react';
import { Container, Button } from 'react-bootstrap';

/**
 * CtaBanner Component
 * A reusable blue call-to-action banner section.
 */
const CtaBanner = () => {
  return (
    <section style={{ backgroundColor: "#213360" }} className="py-4 text-white">
      <Container>
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
          <h4 className="fw-semibold mb-0 fs-5 text-center text-sm-start">
            Build your web App/SaaS with TSM
          </h4>
          <Button
            style={{ backgroundColor: "#f06548", borderColor: "#f06548" }}
            className="px-4 py-2 fw-medium d-flex align-items-center shadow"
          >
            <i className="bi bi-info-circle me-2"></i> Enquire now
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default CtaBanner;
